import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import Register from "./pages/Register";
import RegisterNanny from "./pages/RegisterNanny";
import RegisterClient from "./pages/RegisterClient";
import RegisterNurse from "./pages/RegisterNurse";
import Admin from "./pages/Admin";
import Services from "./pages/Services";
import Profile from "./pages/Profile";
import Nanny from "./pages/Nanny";
import List from "./pages/List";
import ListLimited from "./pages/ListLimited";
import Portfolio from "./pages/Portfolio";
import AppDescription from "./pages/AppDescription";
import Seeker from "./pages/Seeker";
import NurseAdd from "./pages/NurseAdd";
import Veryfnurse from "./pages/Veryfnurse";
import NoPermission from "./pages/NoPermission";
import PolitykaPrywatnosci from "./pages/PolitykaPrywatnosci";
import SwiadczenieWspierajace from "./pages/SwiadczenieWspierajace";
import PassResetMail from "./pages/PassResetMail";
import EnglishUnavailable from "./pages/EnglishUnavailable";
import StroopTest from "./pages/StroopTest";
import MemoryTest from "./pages/MemoryTest";
import NumberTest from "./pages/NumberTest";
import BackTest from "./pages/BackTest";
import WordTest from "./pages/WordTest";
import Rules from "./pages/Rules";
import Prices from "./pages/Prices";
import FAQ from "./pages/FAQ";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import { UserDataProvider } from "./components/UserDataContext";
//import { UserProvider } from "./components/UserDataContext";
import { SearchProvider } from "./components/SearchContext";
import Footer from "./components/Footer";
import CookieSettings from "./components/CookieSettings";
import CountryGuard from "./components/CountryGuard";
//import AppProviders from "./providers/AppProviders";
import { CookieProvider } from "./components/CookieContext";
import CookieBanner from "./components/CookieBanner";
const baseUrl = process.env.REACT_APP_BASE_URL || "/";

function App() {
  return (
    <UserDataProvider>
      <CookieProvider>
        <BrowserRouter basename={baseUrl}>
          <CountryGuard>
            <Routes>
              <Route path="/" element={<Navigate to="/login" />} />
              <Route path="/login" element={<Login />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/nanny" element={<Nanny />} />
              <Route path="/services" element={<Services />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/seeker" element={<Seeker />} />
              <Route path="/nurse-add" element={<NurseAdd />} />
              <Route path="/verify-nurse" element={<Veryfnurse />} />
              <Route path="/register/:id" element={<Register />} />
              <Route path="/registernanny" element={<RegisterNanny />} />
              <Route path="/registerclient" element={<RegisterClient />} />
              <Route path="/registernurse" element={<RegisterNurse />} />
              <Route path="/stroop-test" element={<StroopTest />} />
              <Route path="/memory-test" element={<MemoryTest />} />
              <Route path="/number-test" element={<NumberTest />} />
              <Route path="/back-test" element={<BackTest />} />
              <Route path="/word-test" element={<WordTest />} />
              <Route path="/regulamin" element={<Rules />} />
              <Route path="/cennik" element={<Prices />} />
              <Route path="/faq" element={<FAQ />} />
              <Route
                path="/english-unavailable"
                element={<EnglishUnavailable />}
              />
              <Route
                path="/swiadczenie-wspierajace"
                element={<SwiadczenieWspierajace />}
              />
              <Route path="/pass-reset" element={<PassResetMail />} />
              <Route path="/list" element={<List />} />
              <Route path="/list-limited" element={<ListLimited />} />
              <Route path="/description" element={<AppDescription />} />
              <Route path="/cookies" element={<CookieSettings />} />
              <Route
                path="/polityka-prywatnosci"
                element={<PolitykaPrywatnosci />}
              />
              <Route path="/portfolio/:id" element={<Portfolio />} />
              <Route path="/nopermission" element={<NoPermission />} />
            </Routes>
          </CountryGuard>
          <CookieBanner />
        </BrowserRouter>
      </CookieProvider>
      <Footer />
    </UserDataProvider>
  );
}

export default App;
